import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectCommonProducts = (state: StoreSchema) => state.commonData.common.products
